module.exports = __webpack_public_path__ + "static/MEVP-a44b7f9b02f8a7685fdb28184bedfc6a.png";